import "./App.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import Home from "./sections/Home";
// import About from "./sections/About";
import Skills from "./sections/Skills";
import Experience from "./sections/Experience";
import Projects from "./sections/Projects";
import Education from "./sections/Education";
import Contact from "./sections/Contact";
import Certifications from "./sections/Certifications";

function App() {
  return (
    <div>
      {/* Main layout */}
      <div className="main-container">
        <div className="fixed-section">
          <Home />
        </div>
        <div className="scroll-section">
          <Home />
          {/* <About /> */}
          <Skills />
          <Certifications />
          <Experience />
          <Projects />
          <Education />
          <Contact />
        </div>
      </div>

      {/* Footer */}
      {/* <div className="footer-bar">
        <hr />
        <p>©Finpay 2024. All Rights Reserved.</p>
      </div> */}
    </div>
  );
}

export default App;
